import { lazyLoad } from 'utils/loadable';

const IntegratedAppsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'IntegratedAppsPage', webpackPrefetch: true */ '.'
  ),
);

const HandleShopifyRedirect = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'handleShopifyRedirect', webpackPrefetch: true */ './redirectUri/HandleShopifyRedirect'
  ),
);

// routes declaration
export const IntegratedAppsRoutes = [
  {
    component: IntegratedAppsPage,
    path: '/integrated-apps',
    title: 'Integrated Apps',
    allowedAfterLogin: true,
  },
  {
    component: HandleShopifyRedirect,
    path: '/integrated-apps/shopify/redirect',
    title: 'Shopify Redirect',
    allowedAfterLogin: true,
    hidePublicNavbar: true,
    hideCustomFooter: true,
    hideChatWidget: true,
  },
];
